 
import React from "react"
import { Card, CardBody, Input, FormFeedback } from "reactstrap"

function TicketPricing({ audienceTicketData, validation }) {
  if (!audienceTicketData) return null

  const { audienceType, ageGroup, ticketBooking } = audienceTicketData

  const categories = []

  if (ageGroup?.adult) {
    if (audienceType?.member) categories.push("Adult Member")
    if (audienceType?.nonMember) categories.push("Adult Non Member")
    // if (audienceType?.sponsor) categories.push("Adult Sponsor")
  }

  if (ageGroup?.child) {
    if (audienceType?.member) categories.push("Child Member")
    if (audienceType?.nonMember) categories.push("Child Non Member")
    // if (audienceType?.sponsor) categories.push("Child Sponsor")
  }

  // const showEarlyBird = ticketBooking?.earlyBird
  const showEarlyBird = Boolean(ticketBooking?.earlyBird)

  return (
    <>
        <div className="d-flex align-items-center mb-4">
          <div className="avatar-sm me-3">
            <span className="avatar-title rounded-circle bg-warning bg-soft text-warning font-size-18">
              <i className="mdi mdi-ticket-percent"></i>
            </span>
          </div>
          <div>
            <h5 className="mb-0 fw-semibold">Ticket Pricing Matrix</h5>
            <small className="text-muted">Set early bird and standard pricing per audience category</small>
          </div>
        </div>

        <div className="table-responsive">
          <table className="table table-bordered table-hover align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th className="fw-semibold">Category</th>
                {showEarlyBird && (
                  <th className="fw-semibold text-warning">
                    <i className="mdi mdi-bird me-1"></i>Early Bird Cost
                  </th>
                )}
                <th className="fw-semibold text-primary">Standard Cost</th>
              </tr>
            </thead>
            <tbody>
              {categories.map(category => {
                const key = category.toLowerCase().replace(/ /g, "_")
                const earlyName = `ticketPricing.${key}.early`
                const standardName = `ticketPricing.${key}.standard`
                const earlyError = validation?.touched?.ticketPricing?.[key]?.early && validation?.errors?.ticketPricing?.[key]?.early
                const standardError = validation?.touched?.ticketPricing?.[key]?.standard && validation?.errors?.ticketPricing?.[key]?.standard

                return (
                  <tr key={category}>
                    <td>
                      <span className="badge bg-light text-dark border">{category}</span>
                    </td>
                    {showEarlyBird && (
                      <td>
                        <div className="input-group input-group-sm">
                          <span className="input-group-text bg-warning bg-soft text-warning">$</span>
                          <Input
                            type="number"
                             min="0.01"
  step="0.01"
                            placeholder="0.00"
                            name={earlyName}
                            value={validation.values?.ticketPricing?.[key]?.early || ""}
                            // onChange={validation.handleChange}
                             onChange={(e) => {
                const val = e.target.value
                // FIX: Changed standardName to earlyName below
                if (val === "" || /^\d*\.?\d*$/.test(val)) {
                  validation.setFieldValue(earlyName, val)
                }
              }}
                            onBlur={validation.handleBlur}
                            invalid={!!earlyError}
                            style={{ maxWidth: 140 }}
                          />
                        </div>
                        {earlyError && <FormFeedback className="d-block">{earlyError}</FormFeedback>}
                      </td>
                    )}
                    <td>
                      <div className="input-group input-group-sm">
                        <span className="input-group-text bg-primary bg-soft text-primary">$</span>
                        <Input
                          type="number"
                           min="0.01"
  step="0.01"
                          placeholder="0.00"
                          name={standardName}
                          value={validation.values?.ticketPricing?.[key]?.standard || ""}
                          // onChange={validation.handleChange}
                           onChange={(e) => {
    const val = e.target.value

    // Allow typing like "0." or ""
    if (val === "" || /^\d*\.?\d*$/.test(val)) {
      validation.setFieldValue(standardName, val)
    }
  }}
                          onBlur={validation.handleBlur}
                          invalid={!!standardError}
                          style={{ maxWidth: 140 }}
                        />
                      </div>
                      {standardError && <FormFeedback className="d-block">{standardError}</FormFeedback>}
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
    </>
  )
}

export default TicketPricing
